var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.blank)?_c('router-link',{staticClass:"base-link",attrs:{"to":_vm.to}},[_vm._t("default")],2):_c('a',{staticClass:"base-link",attrs:{"href":_vm.to,"target":"_blank","rel":"noopener noreferrer"}},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1e7ca6a8","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/base/BaseLink.vue
// module id = 927
// module chunks = 0